<template>
  <div class="app-main-content">
    <div style="display:flex;flex-direction:column">
      <el-steps :active="active" simple>
        <el-step :title="$t('Insurance.ChooseServiceProvider')" icon="1">
          <div slot="title">
            <!-- 从保险第一个页面点进去 才显示返回上一页    -->
            <el-button v-if="active === 2 && nowUuid && sourceFrom !== 'page'" style="margin-left: -100px" type="primary" plain @click="backPageHandler">{{ $t('Message.GoBack') }}</el-button>
            <el-button v-if="active === 2 && nowUuid && sourceFrom === 'page'" style="margin-left: -100px" type="primary" plain @click="backHomePageHandler">{{ $t('Message.ReturnToHomepage') }}</el-button>
            <span class="index" style="padding-left: 100px">1</span><span>{{ $t('Insurance.ChooseServiceProvider') }}</span>
          </div>
        </el-step>
        <el-step :title="$t('Insurance.PurchaseInsurance')" icon="2">
          <div slot="title"><span class="index">2</span><span>{{ $t('Insurance.PurchaseInsurance') }}</span></div>
        </el-step>
        <el-step :title="$t('Insurance.ViewInsurancePolicy')" icon="3">
          <div slot="title"><span class="index">3</span><span>{{ $t('Insurance.ViewInsurancePolicy') }}</span></div>
        </el-step>
      </el-steps>
    </div>
    <div v-show="active === 1" style="flex-grow: 1;display: flex;overflow: auto;">
      <policy-home-page ref="policyHomePage" :source-from="sourceFrom" :insure-form="insureForm" @insureSuccess="insureSuccess" />
    </div>
    <div v-show="active === 2" style="flex-grow: 1;display: flex;">
      <insure-iframe ref="insureIframe" :jump-url="jumpUrl" />
    </div>
  </div>
</template>

<script>
import PolicyHomePage from '@/views/cargo/v0/Insurance/components/policyHomePage'
import InsureIframe from '@/views/cargo/v0/Insurance/components/insureIframe'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { matchView } from '@/store/modules/tagsView'
import { checkInsureDeleteFunc, removeInsureRecord } from '@/api/external/insureInfo'

export default {
  name: 'ToInsurePage',
  components: { InsureIframe, PolicyHomePage },
  props: {
    sourceFrom: { type: String, default: 'job' }// 默认job,从货运险首页过来直接发起投保则传递对应取值
  },
  data() {
    return {
      active: 1,
      insureForm: null,
      jumpUrl: '',
      insuranceAgent: '',
      nowUuid: ''
    }
  },
  watch: {
    jumpUrl: {
      async handler(newVal) {
        if (newVal && this.active === 1) {
          this.active = 2
          setTimeout(() => {
            this.$refs.insureIframe.changeAgent(this.insureForm.insuranceAgent)
          }, 500)
        } else if (!newVal && this.active === 2) {
          this.active = 1
          this.doBackPageHandler()
        }
      }
    }
  },
  async mounted() {
    // 跳转第三方保单查询页面
    this.insureForm = this.$route.params.insureForm
    // 若在该页面进行F5刷新则关闭该页面
    if (!this.$route.params.insureForm) {
      const view = { name: 'ToInsurePage', path: '/ToInsurePage', query: this.$route.query, key: this.$route.query.key }
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews)
        }
      })
    }
    if (this.insureForm) {
      if (this.insureForm.insureLink) {
        if (this.insureForm.insureLink) {
          if (this.insureForm.insureLink.indexOf('?') < 1) {
            this.jumpUrl = this.insureForm.insureLink + '?modifyUser=' + this.$store.getters.userId
          } else {
            this.jumpUrl = this.insureForm.insureLink + '&modifyUser=' + this.$store.getters.userId
          }
          this.$logger.log('jumpUrl---------------', this.jumpUrl)
        }
      } else {
        // 若缓存中已经存在勾选记录的代理，则直接进行投保操作
        const obj = LocalStorageUtilsNew.getConfiguration('CURRENT_INSURANCE_AGENT')
        if (obj && obj.agent && obj.date) {
          const time = new Date().getTime()
          // 保持三十天
          if (time - obj.date <= 30 * 24 * 60 * 60 * 1000) {
            setTimeout(() => {
              this.$refs.policyHomePage.toInsure(obj.agent)
            }, 100)
          }
        }
      }
    }
  },
  methods: {
    insureSuccess(data) {
      this.nowUuid = ''
      if (data.uuid) {
        this.nowUuid = data.uuid
      }
      if (data.jumpUrl.indexOf('?') < 1) {
        this.jumpUrl = data.jumpUrl + '?modifyUser=' + this.$store.getters.userId
      } else {
        this.jumpUrl = data.jumpUrl + '&modifyUser=' + this.$store.getters.userId
      }
      this.$logger.log('jumpUrl---------------', this.jumpUrl)
      this.insuranceAgent = data.insuranceAgent
      this.$refs.insureIframe.changeAgent(data.insuranceAgent)
    },
    backPageHandler(e) {
      if (this.nowUuid) {
        checkInsureDeleteFunc({ uuid: this.nowUuid }).then(res => {
          if (res.data === 1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CallBackTip'))
          } else {
            this.$confirm(this.$t('Message.BackPageTip'), this.$t('Message.WarmReminder'), {
              confirmButtonText: this.$t('Message.GoBack'),
              cancelButtonText: this.$t('common.btn.cancel'),
              type: 'warning'
            }).then(() => {
              this.jumpUrl = ''
            }).catch(() => {
            })
          }
        })
      }
    },
    // 返回首页，不进行删除投保单
    backHomePageHandler(e) {
      this.jumpUrl = ''
    },
    doBackPageHandler() {
      if (this.nowUuid) {
        const insureKeys = []
        insureKeys.push(this.nowUuid)
        removeInsureRecord({ insureKeys: insureKeys, insureType: this.sourceFrom === 'page' ? 'INSURE' : '' })
      }
      this.nowUuid = ''
    },
    isActive(route) {
      return matchView(route, this.$route)
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss">
.index{
  margin-right: 5px;
  font-size: 26px!important;
}
</style>

